export const LOGIN_MACO = (state, {loggedIn, token, validUntil}) => {
  state.maco.loggedIn = loggedIn || false
  state.maco.token = token || null
  state.maco.validUntil = validUntil || null
}

export const RESET = (state) => {
  state.maco.loggedIn = false
  state.maco.token = null
  state.maco.validUntil = null
}



// WEBPACK FOOTER //
// ./src/store/modules/tomaner/mutations.js